import React from 'react';
import PropTypes from 'prop-types';
import './ActionButtons.css';

const ActionButtons = ({
  handleConversion,
  handleCopy,
  handlePaste,
  handleClear,
  handlePrint,
  handleSendToEditor,
}) => (
  <div className="button-container">
    <button type="button" onClick={handleConversion}>Convert</button>
    <button type="button" onClick={handleCopy}>Copy</button>
    <button type="button" onClick={handlePaste}>Paste</button>
    <button type="button" onClick={handleClear}>Clear</button>
    <button type="button" onClick={handleSendToEditor}>TxtEdtr-&gt;</button>
    <button type="button" onClick={handlePrint}>Print</button>
  </div>
);

// Prop type validation
ActionButtons.propTypes = {
  handleConversion: PropTypes.func.isRequired,
  handleCopy: PropTypes.func.isRequired,
  handlePaste: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
  handlePrint: PropTypes.func.isRequired,
  handleSendToEditor: PropTypes.func.isRequired,
};

export default ActionButtons;
